import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';

import { setupSubmissionResponse } from '../../../store/shared/dcr-form-submission/form-submission.effects';
import { ContactUsApi } from './api/contact-us-api.service';
import {
  ContactUsActionTypes,
  ContactUsFailed,
  ContactUsSucceeded,
} from './contact-us.actions';
import { ContactUsPayload } from './types/contact-us.state.type';

@Injectable()
export class ContactUsEffects {
  constructor(
    private actions$: Actions,
    private contactUsApi: ContactUsApi,
  ) {}

  contactUsResponse$ = createEffect(() =>
    setupSubmissionResponse(this.actions$, {
      listenTo: ContactUsActionTypes.CONTACT_US_SUBMIT_REQUESTED,
      failure: () => new ContactUsFailed(),
      success: () => new ContactUsSucceeded(),
      apiCall: (payload: ContactUsPayload) =>
        this.contactUsApi.contactUsFormSubmission(payload),
    }),
  );
}
